import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

export const MaskedLines = ({ lines, className = '', delay = 0, lineClassName = '' }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          initial={{ y: '115%' }}
          animate={{ y: '0%' }}
          transition={{ duration: 0.9, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Reveal = ({ children, delay = 0, y = 32, className = '', once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: '-60px' }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ no, label, title, className = '' }) => (
  <div className={`${className}`} data-testid={`chapter-${no}`}>
    <Reveal>
      <div className="flex items-baseline gap-4">
        <span className="font-mono text-sm font-semibold text-volt">/{no}</span>
        <span className="mono-label">{label}</span>
        <span className="hidden h-px flex-1 bg-line sm:block" />
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-6 font-display text-4xl font-black tracking-tight text-parchment sm:text-5xl">
        {title}
      </h2>
    </Reveal>
  </div>
);

export const PageHero = ({ eyebrow, lines, sub, children }) => (
  <header className="noise-overlay relative border-b border-line bg-ink bg-grid">
    <div className="mx-auto max-w-7xl px-6 pb-20 pt-36 sm:pb-28 sm:pt-44 lg:px-10">
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="mono-label text-volt"
        data-testid="page-hero-eyebrow"
      >
        {eyebrow}
      </motion.p>
      <h1 className="mt-6 font-display text-4xl font-black leading-[1.02] tracking-tight text-parchment sm:text-6xl">
        <MaskedLines lines={lines} delay={0.15} />
      </h1>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.65, ease: EASE }}
          className="mt-8 max-w-2xl text-base leading-relaxed text-steel sm:text-lg"
        >
          {sub}
        </motion.p>
      )}
      {children}
    </div>
  </header>
);
